import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isNative } from '@bubble-ui/util-platform';
export var getDefaultStyleSheet = _ref => {
  var {
    customBullet,
    fontSize,
    isLast,
    itemSpaceValue,
    lineHeight,
    noStartPadding,
    ordered
  } = _ref;
  return {
    bulletContainerStyle: {
      alignItems: 'flex-end',
      height: lineHeight,
      justifyContent: 'center',
      // "magic" number to align to figma as close as possible
      marginLeft: noStartPadding ? -fontSize : -(fontSize * 0.4),
      minWidth: fontSize * 2,
      paddingRight: ordered ? noStartPadding ? fontSize / 2 - 6 : fontSize / 2 - 4 : noStartPadding ? fontSize / 2 + 1 : fontSize / 2 + 2,
      // This paddingTop is needed in order to recreate how figma aligns list bullets
      paddingTop: customBullet || ordered ? 0 : lineHeight / 20
    },
    bulletContainerTextStyle: _objectSpread({}, isNative ? {
      fontVariant: ['tabular-nums']
    } : {
      fontFeatureSettings: '"tnum"',
      fontVariantNumeric: 'tabular-nums'
    }),
    listItemStyle: {
      display: 'flex',
      flexDirection: 'row',
      paddingBottom: itemSpaceValue && !isLast ? itemSpaceValue : 0
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map